const FooterBlock = ({ blocks }) => {
  const items = Array.isArray(blocks) ? blocks : []

  if (items.length === 0) return null

  return (
    <div className="bg-white rounded-2xl border border-[#E7EAEF] px-4 sm:px-5 py-3 sm:py-4 mt-4 flex flex-col gap-3">
      {items.map((block) => {
        if (block.type === "text" && block.text) {
          return (
            <p key={block.id} className="text-sm text-[#5A6779] whitespace-pre-wrap break-words">
              {block.text}
            </p>
          )
        }

        if (block.type === "link" && block.url) {
          return (
            <a
              key={block.id}
              href={block.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-[#1E9E5B] hover:underline break-all w-fit max-w-full"
            >
              {block.label || block.url}
            </a>
          )
        }

        return null
      })}
    </div>
  )
}

export default FooterBlock
